import React, { PropTypes, Component } from 'react';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import { Divider } from 'material-ui';
import SinglePickupDropOff from './single-pickupDropoff';
import HelperLink from '../helper-link';
import R, { merge } from 'ramda';
import { connect } from 'react-redux';


const propTypes = {
  pickup: PropTypes.array,
  dropoff: PropTypes.array,
  openAddEditContractDialog: PropTypes.func,
  productType: PropTypes.string,
  supplierEditable: PropTypes.bool,
  contractState: PropTypes.string,
  existingSeasons: PropTypes.array,
  hideHeader: PropTypes.bool,
  classes: PropTypes.object,

  arrayData: PropTypes.array,
  pickupOrDropoff: PropTypes.string,
};
export const PickupDropoffDisplay = props => {
  const {
    hideHeader,
    classes = {},
    openAddEditContractDialog,
    supplierEditable,
    arrayData = [],
    existingSeasons = [],
    pickupOrDropoff,
  } = props;
  if (!arrayData.length) return <div />;
  return (
    <MouseOverEditDiv
      className={classes.main}
      regularDiv={
        arrayData.length > 1 && R.any(R.compose(R.isEmpty, R.prop('dateRanges')), existingSeasons)
      }
      hintOnRight
      editable={supplierEditable}
      singleLineTitle
      actionButtons={
        <EditButton
          onEdit={() => {
            openAddEditContractDialog({
              type: 'pickupDropoff',
              title:
                pickupOrDropoff === 'pickup'
                  ? 'Edit Pick-up / Opening Information'
                  : 'Edit Drop-off / Closing Information',
              data: {
                pickupOrDropoff,
              },
            });
          }}
        />
      }
    >
      {!hideHeader && (
        <HelperLink value={pickupOrDropoff}>
          {pickupOrDropoff === 'pickup' ? 'Pick Up / Opening' : 'Drop Off / Closing'}
        </HelperLink>
      )}
      {!hideHeader && <br />}
      {/*
         <SeasonErrors
         {...contractingPeriod}
         seasonDateRanges={flatten(allDateRangesPickup)}
         />
         <br/>
         */}
      {arrayData.map((ele, index) => {
        const data =
          arrayData.length === existingSeasons.length && arrayData.length > 1
            ? existingSeasons[index]
            : ele;
        const { dateRanges } = data || ele;
        return (
          <SinglePickupDropOff key={index} index={index} {...merge(ele, { dateRanges, classes })} />
        );
      })}
    </MouseOverEditDiv>
  );
};
PickupDropoffDisplay.propTypes = propTypes;

class RightFourPickUpDropOff extends Component {
  shouldComponentUpdate(nextProps) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps));
  }

  render() {
    const {
      openAddEditContractDialog,
      supplierEditable,
      pickup = [],
      dropoff = [],
      productType,
    } = this.props;
    if (productType === 'Accommodation') return <div />;
    const fontFamily = "'Open Sans','Helvetica Neue',Helvetica,Arial,sans-serif";
    return (
      <div style={{ fontFamily }} id="pickupDropoff">
        <Divider style={{ marginTop: '24px', marginBottom: '16px' }} />
        {pickup && pickup.length ? (
          <PickupDropoffDisplay {...this.props} pickupOrDropoff="pickup" arrayData={pickup} />
        ) : (
          <div>
            <HelperLink value="pickup" labelStyle={{ marginBottom: '12px' }}>
              Pick Up / Opening
            </HelperLink>
            <AddItemCard
              onClick={() =>
                openAddEditContractDialog({
                  type: 'pickupDropoff',
                  title: 'Add Pick-up / Opening Information',
                  data: {
                    pickupOrDropoff: 'pickup',
                  },
                })
              }
              text="Add pick-up / opening information"
              editable={supplierEditable}
            />
          </div>
        )}
        <br />
        {dropoff && dropoff.length ? (
          <PickupDropoffDisplay {...this.props} pickupOrDropoff="dropoff" arrayData={dropoff} />
        ) : (
          <div>
            <HelperLink value="dropoff" labelStyle={{ marginBottom: '12px' }}>
              Drop Off / Closing
            </HelperLink>
            <AddItemCard
              onClick={() =>
                openAddEditContractDialog({
                  type: 'pickupDropoff',
                  title: 'Add Drop-off / Closing Information',
                  data: {
                    pickupOrDropoff: 'dropoff',
                  },
                })
              }
              text="Add drop-off / closing information"
              editable={supplierEditable}
            />
          </div>
        )}
      </div>
    );
  }
}
RightFourPickUpDropOff.propTypes = propTypes;

const mapStateToProps = ({ contracting }, { reducerName, pickup, dropoff }) => {
  if (pickup) return { pickup };
  if (dropoff) return { dropoff };
  return {
    pickup: contracting[reducerName].getIn(['rightSideContent', 'pickup'])
      ? contracting[reducerName].getIn(['rightSideContent', 'pickup']).toJS()
      : [],
    dropoff: contracting[reducerName].getIn(['rightSideContent', 'dropoff'])
      ? contracting[reducerName].getIn(['rightSideContent', 'dropoff']).toJS()
      : [],
  };
};
export default connect(mapStateToProps)(RightFourPickUpDropOff);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/product/right-column/right-four-pickup-dropoff.jsx